import React, { useState, useEffect } from "react"

const GlobalISI = ({ site = false }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleIsi = (e) => {
    let isi = document.querySelector(".global-isi")
    setIsOpen(!isOpen)
    isi.classList.toggle("close")
    document.body.classList.toggle("isi-lock");
  }

  const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, "\\$&")
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ""
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  }

  let observer // Declare observer in the outer scope
  let isiElement
  let isiFloatElement

  // Define the addHiddenClassOnScroll function
  const addHiddenClassOnScroll = () => {
    isiElement = document.querySelector(".isi-intersection")
    isiFloatElement = document.querySelector(".global-isi")

    if (!isiElement || !isiFloatElement) {
      // Check if the elements exist
      console.error("Elements not found.")
      return
    }

    if (getParameterByName("screenshot") == "true")
      isiFloatElement.classList.add("inline")

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        //console.log(entry)
        //console.log(entry)
        if (getParameterByName("screenshot") == "true") {
          isiFloatElement.classList.add("inline")
        } else {
          if (entry.isIntersecting) {
            if (isiFloatElement.classList.contains("close")) {
              isiFloatElement.classList.add("inline")
              console.log("intersecting")
            }
          } else {
            //console.log('not intersecting')
            isiFloatElement.classList.remove("inline") // Remove the "hidden" class when not in view
          }
        }
      })
    })

    observer.observe(isiElement)
  }

  useEffect(() => {
    // Call the function when the component mounts
    addHiddenClassOnScroll()

    // Cleanup function to disconnect the IntersectionObserver
    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    let windowScrollTimeout = setTimeout(() => {
      window.scrollTo(0, 0)
      clearTimeout(windowScrollTimeout)
    }, 1)
  }, [])

  useEffect(() => {
    // Ensure this runs only in the browser
    if (typeof window !== "undefined") {
      const hash = window.location.hash
      // Check if the URL contains '#isi'
      if (hash === "#isi") {
        // Find the element with ID 'isi'
        const isiElement = document.getElementById("isi")
        if (isiElement) {
          // Find the child of isiElement with the class 'global-isi'
          const globalIsiElement = isiElement.querySelector(".global-isi")
          if (globalIsiElement) {
            // Add the 'inline' class to globalIsiElement
            globalIsiElement.classList.add("inline")

            // After a 0.5-second delay, scroll to the offset top of global-isi
            setTimeout(() => {
              const offsetPosition = globalIsiElement.offsetTop
              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              })
            }, 1500) // 0.5 seconds delay
          }
        }
      }
    }
  }, [])

  /*
    useEffect(()=>{
        let htmlElement = document.documentElement;
        if(isiOpen){
          htmlElement.classList.add('isi-lock');
        }else{
          htmlElement.classList.remove('isi-lock');
        }
      },[isiOpen]);*/

  return (
    <>
      {site && (
        <div className={`global-isi ${site} close`}>
          <div className="toggle-btn" onClick={toggleIsi}>
            {isOpen ? <>Collapse <span className="plus-minus">-</span></> : <>Expand <span className="plus-minus">+</span></>}
          </div>
          <div className="content-wrapper">
            {site == "gateway" && (
              <>
                <div className="swappable">
                  <div>
                    <p className="isi-header">INDICATION</p>
                    <p>
                      AYVAKIT<sup className="reg_mark">&reg;</sup> (avapritinib)
                      is indicated for the treatment of adult patients with:
                    </p>
                    <ul className="mt--1 md_mt--1 lg_mt--1">
                      <li>
                        <span>
                          Unresectable or metastatic gastrointestinal stromal
                          tumor (GIST) harboring a platelet-derived growth
                          factor receptor alpha (PDGFRA) exon 18 mutation,
                          including PDGFRA D842V mutations, and
                        </span>
                      </li>
                      <li>
                        <span>
                          Advanced SM (AdvSM) including patients with aggressive
                          systemic mastocytosis (ASM), systemic mastocytosis
                          with an associated hematological neoplasm (SM-AHN),
                          and mast cell leukemia (MCL).
                          <br />
                          <span className="underline">Limitations of Use</span>:
                          AYVAKIT is not recommended for the treatment of
                          patients with AdvSM with platelet counts of &lt;50 x
                          10<sup>9</sup>/L.
                        </span>
                      </li>
                      <li>
                        <span>
                          Indolent systemic mastocytosis (ISM).
                          <br />
                          <span className="underline">Limitations of Use</span>:
                          AYVAKIT is not recommended for the treatment of
                          patients with ISM with platelet counts of &lt;50 x 10
                          <sup>9</sup>/L.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <p className="isi-header desktop-only">
                      IMPORTANT SAFETY INFORMATION
                    </p>
                    <p className="isi-header mobile-only">
                      INDICATION & IMPORTANT SAFETY INFORMATION
                    </p>
                    <p>
                      <strong>Intracranial Hemorrhage&mdash;</strong>Serious
                      intracranial hemorrhage (ICH) may occur with AYVAKIT
                      treatment; fatal events occurred in &lt;1% of patients.
                      Overall, ICH (e.g., subdural hematoma, ICH, and cerebral
                      hemorrhage) occurred in 2.9% of 749 patients who received
                      AYVAKIT in clinical trials. In GIST patients, ICH occurred
                      in 3 of 267 patients (1.1%) and two (0.7%) of the events
                      were Grade <span className="ge-char">&ge;</span>3 and
                      resulted in discontinuation. In AdvSM patients who
                      received AYVAKIT at 200 mg daily, ICH occurred in 2 of 75
                      patients (2.7%) who had platelet counts{" "}
                      <span className="ge-char">&ge;</span>50 x 10<sup>9</sup>/L
                      prior to initiation of therapy and in 3 of 80 patients
                      (3.8%) regardless of platelet counts. In ISM patients, no
                      events of ICH occurred in the 246 patients who received
                      any dose of AYVAKIT in the PIONEER study.
                    </p>
                    <p>
                      Monitor patients closely for risk factors of ICH which may
                      include history of vascular aneurysm, ICH or
                      cerebrovascular accident within the prior year,
                      concomitant use of anticoagulant drugs, or
                      thrombocytopenia. Symptoms of ICH may include headache,
                      nausea, vomiting, vision changes, or altered mental
                      status. Advise patients to seek immediate medical
                      attention for signs or symptoms of ICH. Permanently
                      discontinue AYVAKIT if ICH of any grade occurs.
                    </p>
                    <p>
                      In AdvSM patients, a platelet count must be performed
                      prior to initiating therapy. AYVAKIT is not recommended in
                      AdvSM patients with platelet counts &lt;50 x 10
                      <sup>9</sup>/L. Following treatment initiation, platelet
                      counts must be performed every 2 weeks for the first 8
                      weeks. After 8 weeks of treatment, monitor platelet counts
                      every 2 weeks or as clinically indicated based on platelet
                      counts. Manage platelet counts of &lt;50 x 10<sup>9</sup>
                      /L by treatment interruption or dose reduction.
                    </p>
                    <p>
                      <strong>Cognitive Effects&mdash;</strong>Cognitive adverse
                      reactions can occur in patients receiving AYVAKIT and
                      occurred in 33% of 995 patients overall in patients who
                      received AYVAKIT in clinical trials including: 41% of 601
                      GIST patients (5% were Grade{" "}
                      <span className="ge-char">&ge;</span>3), 28% of 148 AdvSM
                      patients (3% were Grade{" "}
                      <span className="ge-char">&ge;</span>3), and 7.8% of
                      patients with ISM who received AYVAKIT + best supportive
                      care (BSC) versus 7.0% of patients who received placebo +
                      BSC (&lt;1% were Grade 3). Depending on the severity and
                      indication, withhold AYVAKIT and then resume at same dose
                      or at a reduced dose upon improvement, or permanently
                      discontinue.
                    </p>
                    <p>
                      <strong>Photosensitivity&mdash;</strong>AYVAKIT may cause
                      photosensitivity reactions. In all patients treated with
                      AYVAKIT in clinical trials (n=1049), photosensitivity
                      reactions occurred in 2.5% of patients. Advise patients to
                      limit direct ultraviolet exposure during treatment with
                      AYVAKIT and for one week after discontinuation of
                      treatment.
                    </p>
                    <p>
                      <strong>Embryo-Fetal Toxicity&mdash;</strong>AYVAKIT can
                      cause fetal harm when administered to a pregnant woman.
                      Advise pregnant women of the potential risk to a fetus.
                      Advise females and males of reproductive potential to use
                      an effective contraception during treatment with AYVAKIT
                      and for 6 weeks after the final dose of AYVAKIT. Advise
                      women not to breastfeed during treatment with AYVAKIT and
                      for 2 weeks following the final dose.
                    </p>
                    <p>
                      <strong>Adverse Reactions&mdash;</strong>The most common
                      adverse reactions (<span className="ge-char">&ge;</span>
                      20%) in patients with unresectable or metastatic GIST were
                      edema, nausea, fatigue/asthenia, cognitive impairment,
                      vomiting, decreased appetite, diarrhea, increased
                      lacrimation, abdominal pain, constipation, rash,
                      dizziness, and hair color changes.
                      <br/>
                      The most common adverse reactions (
                      <span className="ge-char">&ge;</span>20%) in patients with
                      AdvSM were edema, diarrhea, nausea, and fatigue/asthenia.
                      <br/>
                      The most common adverse reactions (
                      <span className="ge-char">&ge;</span>10%) in patients with
                      ISM were eye edema, dizziness, peripheral edema, and
                      flushing.
                    </p>
                    <p>
                      <strong>Drug Interactions&mdash;</strong>Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inhibitors. If coadministration with a moderate CYP3A
                      inhibitor cannot be avoided in patients with GIST or
                      AdvSM, reduce dose of AYVAKIT. Avoid coadministration of
                      AYVAKIT with strong or moderate CYP3A inducers. If
                      contraception requires estrogen, limit ethinyl estradiol
                      to <span className="ge-char">&le;</span>20 mcg unless a
                      higher dose is necessary.
                    </p>
                    <p>
                      To report suspected adverse reactions, contact Blueprint
                      Medicines Corporation at{" "}
                      <a href="tel:+18882587768" className="isi-phone-link">
                        1-888-258-7768
                      </a>{" "}
                      or the FDA at{" "}
                      <a href="tel:+18003321088" className="isi-phone-link">
                        1-800-FDA-1088
                      </a>{" "}
                      or{" "}
                      <a
                        className="above-accent"
                        href="https://www.fda.gov/medwatch"
                        target="_blank"
                      >
                        www.fda.gov/medwatch
                      </a>
                      .
                    </p>
                    <p>
                      AYVAKIT is available in 25-mg, 50-mg, 100-mg, 200-mg, and
                      300-mg tablets.
                    </p>
                    <p>
                      <strong>
                        Please click here to see the full{" "}
                        <a
                          href="https://www.blueprintmedicines.com/wp-content/uploads/uspi/AYVAKIT.pdf"
                          download
                          target="_blank"
                        >
                          Prescribing Information
                        </a>{" "}
                        for AYVAKIT.
                      </strong>
                    </p>
                  </div>
                </div>
              </>
            )}
            {site == "ism" && (
              <>
                <div className="swappable">
                  <div>
                    <p className="isi-header">INDICATION</p>
                    <p>
                      AYVAKIT<sup className="reg_mark">&reg;</sup> (avapritinib)
                      is indicated for the treatment of adult patients with
                      indolent systemic mastocytosis (ISM).
                    </p>
                    <p>
                      <span className="underline">Limitations of Use</span>:
                      AYVAKIT is not recommended for the treatment of patients
                      with ISM with platelet counts of &lt;50 x 10<sup>9</sup>
                      /L.
                    </p>
                  </div>
                  <div>
                    <p className="isi-header desktop-only">
                      IMPORTANT SAFETY INFORMATION
                    </p>
                    <p className="isi-header mobile-only">
                      INDICATION & IMPORTANT SAFETY INFORMATION
                    </p>
                    {/* <p>
                      <strong>Intracranial Hemorrhage (ICH)&mdash;</strong>
                      Serious ICH may occur with AYVAKIT treatment; fatal events
                      occurred in &lt;1% of patients. No events of ICH occurred
                      in the 246 patients with ISM who received any dose of
                      AYVAKIT in the PIONEER study.
                    </p>
                    <p>
                      Monitor patients closely for risk factors of ICH which may
                      include history of vascular aneurysm, ICH or
                      cerebrovascular accident within the prior year,
                      concomitant use of anticoagulant drugs, or
                      thrombocytopenia.
                    </p>
                    <p>
                      Symptoms of ICH may include headache, nausea, vomiting,
                      vision changes, or altered mental status. Advise patients
                      to seek immediate medical attention for signs or symptoms
                      of ICH.
                    </p>
                    <p>
                      Permanently discontinue AYVAKIT if ICH of any grade
                      occurs.
                    </p> */}
                    <p>
                      <strong>Cognitive Effects&mdash;</strong>Cognitive adverse
                      reactions can occur in patients receiving AYVAKIT and
                      occurred in 7.8% of patients with ISM who received AYVAKIT
                      + best supportive care (BSC) versus 7.0% of patients who
                      received placebo + BSC; &lt;1% were Grade 3. Depending on
                      the severity, withhold AYVAKIT and then resume at the same
                      dose, or permanently discontinue AYVAKIT.
                    </p>
                    <p>
                      <strong>Photosensitivity&mdash;</strong>AYVAKIT may cause
                      photosensitivity reactions. In all patients treated with
                      AYVAKIT in clinical trials (n=1049), photosensitivity
                      reactions occurred in 2.5% of patients. Advise patients to
                      limit direct ultraviolet exposure during treatment with
                      AYVAKIT and for one week after discontinuation of
                      treatment.
                    </p>
                    <p>
                      <strong>Embryo-Fetal Toxicity&mdash;</strong>AYVAKIT can
                      cause fetal harm when administered to a pregnant woman.
                      Advise pregnant women of the potential risk to a fetus.
                      Advise females and males of reproductive potential to use
                      an effective contraception during treatment with AYVAKIT
                      and for 6 weeks after the final dose. Advise women not to
                      breastfeed during treatment with AYVAKIT and for 2 weeks
                      following the final dose.
                    </p>
                    <p>
                      <strong>Adverse Reactions&mdash;</strong>The most common
                      adverse reactions (<span className="ge-char">&ge;</span>
                      10%) in patients with ISM were eye edema, dizziness,
                      peripheral edema, and flushing.
                    </p>
                    <p>
                      <strong>Drug Interactions&mdash;</strong>Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inhibitors or inducers. If contraception requires
                      estrogen, limit ethinyl estradiol to{" "}
                      <span className="ge-char">&le;</span>20 mcg unless a
                      higher dose is necessary.
                    </p>
                    <p>
                      To report suspected adverse reactions, contact Blueprint
                      Medicines Corporation at{" "}
                      <a href="tel:+18882587768" className="isi-phone-link">
                        1-888-258-7768
                      </a>{" "}
                      or the FDA at{" "}
                      <a href="tel:+18003321088" className="isi-phone-link">
                        1-800-FDA-1088
                      </a>{" "}
                      or visit{" "}
                      <a
                        className="above-accent"
                        href="https://www.fda.gov/medwatch"
                        target="_blank"
                      >
                        www.fda.gov/medwatch
                      </a>
                      .
                    </p>
                    <p>
                      <strong>
                        Please click here to see the full{" "}
                        <a
                          href="https://www.blueprintmedicines.com/wp-content/uploads/uspi/AYVAKIT.pdf"
                          download
                          target="_blank"
                        >
                          Prescribing Information
                        </a>{" "}
                        for AYVAKIT.
                      </strong>
                    </p>
                    <p className="ref-title">
                      <strong>References:</strong>
                    </p>
                    <ol className="ref-content">
                      <li>
                        <span>
                          AYVAKIT [prescribing information]. Cambridge, MA:
                          Blueprint Medicines Corporation; November 2024.
                        </span>
                      </li>
                      <li>
                        <span>
                          Kristensen T et al. <em>Am J Hematol</em>.
                          2014;89(5):493-498.
                        </span>
                      </li>
                      <li>
                        <span>
                          Garcia-Montero AC et al. <em>Blood</em>.
                          2006;108(7):2366-2372.
                        </span>
                      </li>
                      <li>
                        <span>
                          Ungerstedt J et al. <em>Cancers</em>.
                          2022;14(16):3942.
                        </span>
                      </li>
                      <li>
                        <span>
                          Pardanani A. <em>Am J Hematol</em>.
                          2023;98(7):1097-1116.
                        </span>
                      </li>
                      <li>
                        <span>
                          Data on file. Blueprint Medicines Corporation,
                          Cambridge, MA. 2023.
                        </span>
                      </li>
                      <li>
                        <span>
                          Gülen T et al. <em>J Intern Med</em>.
                          2016;279(3):211-228.
                        </span>
                      </li>
                      <li>
                        <span>
                          Theoharides TC et al. <em>N Engl J Med</em>.
                          2015;373(2):163-172.
                        </span>
                      </li>
                      <li>
                        <span>
                          Gotlib J et al. <em>NEJM Evidence</em>. 2023;2(6).
                          Published online May 23, 2023.
                          doi:10.1056/EVIDoa2200339
                        </span>
                      </li>
                      <li>
                        <span>
                          Gilreath JA et al. <em>Clin Pharmacol</em>.
                          2019;11:77-92.
                        </span>
                      </li>
                      <li>
                        <span>
                          Evans EK et al. <em>Sci Transl Med</em>.
                          2017;9(414):eaao1690.
                        </span>
                      </li>
                      <li>
                        <span>
                          Padilla B et al. <em>Orphanet J Rare Dis</em>.
                          2021;16(1):434.
                        </span>
                      </li>
                      <li>
                        <span>
                          van Anrooij B et al. <em>Allergy</em>.
                          2016;71(11):1585-1593.
                        </span>
                      </li>
                      <li>
                        <span>
                          WHO Classification of Tumours Editorial Board.
                          Haematolymphoid tumours [Internet]. Lyon (France):
                          International Agency for Research on Cancer; 2024
                          [cited April 24, 2024]. (
                          <em>WHO Classification of Tumours Series</em>, 5th
                          ed.; vol. 11). Available from:{" "}
                          <span className="wordbreak">
                            https://tumourclassification.iarc.who.int/chapters/63
                          </span>
                        </span>
                      </li>
                      <li>
                        <span>
                          Dranitsaris G et al. <em>J Oncol Pharm Pract</em>.
                          Published online December 27, 2023.
                          doi:10.1177/10781552231221149
                        </span>
                      </li>
                      <li>
                        <span>
                          Siebenhaar F et al.{" "}
                          <em>Immunol Allergy Clin North Am</em>.
                          2014;34(2):433-447.
                        </span>
                      </li>
                      <li>
                        <span>
                          Jennings SV et al.{" "}
                          <em>Immunol Allergy Clin North Am</em>.
                          2018;38(3):505-525.
                        </span>
                      </li>
                      <li>
                        <span>
                          Akin C, ed.{" "}
                          <em>Mastocytosis: A Comprehensive Guide</em>.
                          Springer; 2020.
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </>
            )}
            {site == "advsm" && (
              <>
                <div className="swappable">
                  <div>
                    <h6>INDICATION</h6>
                    <p>
                      AYVAKIT<sup className="reg_mark">&reg;</sup> (avapritinib)
                      is indicated for the treatment of adult patients with
                      advanced SM (AdvSM) including patients with aggressive
                      systemic mastocytosis (ASM), systemic mastocytosis with an
                      associated hematological neoplasm (SM-AHN), and mast cell
                      leukemia (MCL).
                    </p>
                    <p>
                      <span className="underline">Limitations of Use</span>:
                      AYVAKIT is not recommended for the treatment of patients
                      with AdvSM with platelet counts of &lt;50 x 10<sup>9</sup>
                      /L.
                    </p>
                  </div>
                  <div>
                    <h6 className="desktop-only">
                      IMPORTANT SAFETY INFORMATION
                    </h6>
                    <h6 className="mobile-only">
                      INDICATION & IMPORTANT SAFETY INFORMATION
                    </h6>
                    <p>
                      <strong>Intracranial Hemorrhage&mdash;</strong>Serious
                      intracranial hemorrhage &#40;ICH&#41; may occur with
                      AYVAKIT treatment; fatal events occurred in &lt;1% of
                      patients. Overall, ICH &#40;e.g.,&nbsp;subdural hematoma,
                      ICH, and cerebral hemorrhage&#41; occurred in 2.9% of 749
                      patients who received AYVAKIT in clinical trials. In AdvSM
                      patients who received AYVAKIT at 200 mg daily, ICH
                      occurred in 2 of 75 patients &#40;2.7%&#41; who had
                      platelet counts <span className="ge-char">&ge;</span>50 x
                      10<sup>9</sup>/L prior to initiation of therapy and in 3
                      of 80 patients &#40;3.8%&#41; regardless of platelet
                      counts.
                    </p>
                    <p>
                      Monitor patients closely for risk factors of ICH which may
                      include history of vascular aneurysm, ICH or
                      cerebrovascular accident within the prior year,
                      concomitant use of anticoagulant drugs, or
                      thrombocytopenia. Symptoms of ICH may include headache,
                      nausea, vomiting, vision changes, or altered mental
                      status. Advise patients to seek immediate medical
                      attention for signs or symptoms of ICH. Permanently
                      discontinue AYVAKIT if ICH of any grade occurs.
                    </p>
                    <p>
                      A platelet count must be performed prior to initiating
                      therapy. AYVAKIT is not recommended in AdvSM patients with
                      platelet counts &lt;50 x 10<sup>9</sup>/L. Following
                      treatment initiation, platelet counts must be performed
                      every 2 weeks for the first 8 weeks. After 8 weeks of
                      treatment, monitor platelet counts every 2 weeks or as
                      clinically indicated based on platelet counts. Manage
                      platelet counts of &lt;50 x 10<sup>9</sup>/L by treatment
                      interruption or dose reduction.
                    </p>
                    <p>
                      <strong>Cognitive Effects&mdash;</strong>Cognitive adverse
                      reactions can occur in patients receiving AYVAKIT and
                      occurred in 33% of 995 patients overall in patients who
                      received AYVAKIT in clinical trials including 28% of 148
                      AdvSM patients (3% were Grade{" "}
                      <span className="ge-char">&ge;</span>3). Depending on the
                      severity and indication, withhold AYVAKIT and then resume
                      at same dose or at a reduced dose upon improvement, or
                      permanently discontinue.
                    </p>
                    <p>
                      <strong>Photosensitivity&mdash;</strong>AYVAKIT may cause
                      photosensitivity reactions. In all patients treated with
                      AYVAKIT in clinical trials (n=1049), photosensitivity
                      reactions occurred in 2.5% of patients. Advise patients to
                      limit direct ultraviolet exposure during treatment with
                      AYVAKIT and for one week after discontinuation of
                      treatment.
                    </p>
                    <p>
                      <strong>Embryo-Fetal Toxicity&mdash;</strong>AYVAKIT can
                      cause fetal harm when administered to a pregnant woman.
                      Advise pregnant women of the potential risk to a fetus.
                      Advise females and males of reproductive potential to use
                      an effective contraception during treatment with AYVAKIT
                      and for 6 weeks after the final dose of AYVAKIT. Advise
                      women not to breastfeed during treatment with AYVAKIT and
                      for 2 weeks following the final dose.
                    </p>
                    <p>
                      <strong>Adverse Reactions&mdash;</strong>The most common
                      adverse reactions (<span className="ge-char">&ge;</span>
                      20%) were edema, diarrhea, nausea, and fatigue/asthenia.
                    </p>
                    <p>
                      <strong>Drug Interactions&mdash;</strong>Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inhibitors. If coadministration with a moderate CYP3A
                      inhibitor cannot be avoided, reduce dose of AYVAKIT. Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inducers. If contraception requires estrogen, limit
                      ethinyl estradiol to <span className="ge-char">&le;</span>
                      20 mcg unless a higher dose is necessary.
                    </p>
                    <p>
                      To report suspected adverse reactions, contact Blueprint
                      Medicines Corporation at 1-888-258-7768 or the FDA at
                      1-800-FDA-1088 or{" "}
                      <a
                        className="above-accent"
                        href="https://www.fda.gov/medwatch"
                        target="_blank"
                      >
                        www.fda.gov/medwatch
                      </a>
                      .
                    </p>
                    <p>
                      AYVAKIT is available in 25-mg, 50-mg, 100-mg, and 200-mg
                      tablets.
                    </p>
                    <p>
                      <strong>
                        Please click here to see the full{" "}
                        <a
                          href="https://www.blueprintmedicines.com/wp-content/uploads/uspi/AYVAKIT.pdf"
                          download
                          target="_blank"
                        >
                          Prescribing Information
                        </a>{" "}
                        for AYVAKIT.
                      </strong>
                    </p>
                    <p>
                      <strong>References:</strong>
                    </p>
                    <ol class="advsm-references">
                      <li>
                        <span>
                          AYVAKIT [prescribing information]. Cambridge, MA:
                          Blueprint Medicines Corporation; November 2024.
                        </span>
                      </li>
                      <li>
                        <span>
                          Referenced with permission from the NCCN Clinical
                          Practice Guidelines in Oncology (NCCN Guidelines®) for
                          Systemic Mastocytosis V.3.2024. © National
                          Comprehensive Cancer Network, Inc. 2024. All rights
                          reserved. Accessed September 18, 2024. To view the
                          most recent and complete version of the guideline, go
                          online to NCCN.org. NCCN makes no warranties of any
                          kind whatsoever regarding their content, use or
                          application and disclaims any responsibility for their
                          application or use in any way.
                        </span>
                      </li>
                      <li>
                        <span>
                          Gilreath JA et al. <em>Clin Pharmacol.</em>{" "}
                          2019;11:77-92.
                        </span>
                      </li>
                      <li>
                        <span>
                          Verstovsek S. <em>Eur J Haematol.</em>{" "}
                          2013;90(2):89-98.
                        </span>
                      </li>
                      <li>
                        <span>
                          Garcia-Montero AC et al. <em>Blood.</em>{" "}
                          2006;108(7):‍2366-2372.
                        </span>
                      </li>
                      <li>
                        <span>
                          Kristensen T et al. <em>Am J Hematol.</em>{" "}
                          2014;89(5):493-498.
                        </span>
                      </li>
                      <li>
                        <span>
                          Data on file. Blueprint Medicines Corporation,
                          Cambridge, MA. 2021.
                        </span>
                      </li>
                      <li>
                        <span>
                          Gotlib J et al. <em>Blood.</em>{" "}
                          2013;121(13):‍2393-2401.
                        </span>
                      </li>
                      <li>
                        <span className="wordbreak">
                          WHO Classification of Tumours Editorial Board.
                          Haematolymphoid tumours [Internet]. Lyon (France):
                          International Agency for{" "}
                          <span className="nobreak">Research</span> on Cancer;
                          2024 [cited April 24, 2024]. (
                          <em>WHO Classification of Tumours Series</em>, 5th
                          ed.; vol. 11). Available from:{" "}
                          <a
                            href="https://tumourclassification.iarc.who.int/chapters/63"
                            target="_blank"
                          >
                            https://tumourclassification.iarc.who.int/chapters/63
                          </a>
                        </span>
                      </li>
                      <li>
                        <span>
                          Pardanani A. <em>Am J Hematol.</em>{" "}
                          2023;98(7):1097-1116.
                        </span>
                      </li>
                      <li>
                        <span>
                          Theoharides TC et al. <em>N Engl J Med.</em>{" "}
                          2015;373(2):163-172.
                        </span>
                      </li>
                      <li>
                        <span>
                          Pardanani A et al. <em>Blood.</em>{" "}
                          2009;114(18):‍3769-3772.
                        </span>
                      </li>
                      <li>
                        <span>
                          Passamonti F, Maffioli M.{" "}
                          <em>Hematology Am Soc Hematol Educ Program.</em>{" "}
                          2016;2016(1):534-542.
                        </span>
                      </li>
                      <li>
                        <span>
                          Valent P et al. <em>Blood.</em>{" "}
                          2017;129(11):1420-1427.
                        </span>
                      </li>
                      <li>
                        <span>
                          Stoecker MM, Wang E. <em>Arch Pathol Lab Med.</em>{" "}
                          2012;136(7):832-838.
                        </span>
                      </li>
                      <li>
                        <span>
                          Arber DA et al. <em>Blood.</em>{" "}
                          2016;127(20):‍2391-2405.
                        </span>
                      </li>
                      <li>
                        <span>
                          Greiner G et al. <em>Clin Chem.</em>{" "}
                          2018;64(3):547-555.
                        </span>
                      </li>
                      <li>
                        <span>
                          Gotlib J et al. <em>Nat Med.</em>{" "}
                          2021;27(12):‍2192-2199.
                        </span>
                      </li>
                      <li>
                        <span>
                          Kwon J. <em>Blood Res.</em> 2021;56(suppl 1):S5-S16.
                        </span>
                      </li>
                      <li>
                        <span>
                          Meggendorfer M et al. <em>Blood.</em>{" "}
                          2012;120(15):‍3080-3088.
                        </span>
                      </li>
                      <li>
                        <span>
                          Greenberg PL et al. <em>Blood.</em>{" "}
                          2012;120(12):‍2454-2465.
                        </span>
                      </li>
                      <li>
                        <span>
                          Malcovati L et al. <em>Blood.</em>{" "}
                          2020;136(2):157-170.
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </>
            )}
            {site == "gist" && (
              <>
                <div className="swappable">
                  <div>
                    <h6>INDICATION</h6>
                    <p>
                      AYVAKIT<sup className="reg_mark">&reg;</sup> (avapritinib)
                      is indicated for the treatment of adult patients with
                      unresectable or metastatic gastrointestinal stromal tumor
                      (GIST) harboring a platelet-derived growth factor receptor
                      alpha (PDGFRA) exon 18 mutation, including PDGFRA D842V
                      mutations.
                    </p>
                  </div>
                  <div>
                    <h6 className="desktop-only">
                      IMPORTANT SAFETY INFORMATION
                    </h6>
                    <h6 className="mobile-only">
                      INDICATION & IMPORTANT SAFETY INFORMATION
                    </h6>
                    <p>
                      <strong>Intracranial Hemorrhage&mdash;</strong>Serious
                      intracranial hemorrhage (ICH) may occur with AYVAKIT
                      treatment; fatal events occurred in &lt;1% of patients.
                      Overall, ICH (e.g., subdural hematoma, ICH, and cerebral
                      hemorrhage) occurred in 2.9% of 749 patients who received
                      AYVAKIT in clinical trials. In GIST patients, ICH occurred
                      in 3 of 267 patients (1.1%) and two (0.7%) of the events
                      were Grade <span className="ge-char">&ge;</span>3 and
                      resulted in discontinuation.
                    </p>
                    <p>
                      Monitor patients closely for risk factors of ICH which may
                      include history of vascular aneurysm, ICH or
                      cerebrovascular accident within the prior year,
                      concomitant use of anticoagulant drugs, or
                      thrombocytopenia. Symptoms of ICH may include headache,
                      nausea, vomiting, vision changes, or altered mental
                      status. Advise patients to seek immediate medical
                      attention for signs or symptoms of ICH. Permanently
                      discontinue AYVAKIT if ICH of any grade occurs.
                    </p>
                    <p>
                      <strong>Cognitive Effects&mdash;</strong>Cognitive adverse
                      reactions can occur in patients receiving AYVAKIT and
                      occurred in 33% of 995 patients overall in patients who
                      received AYVAKIT in clinical trials including: 41% of 601
                      GIST patients (5% were Grade{" "}
                      <span className="ge-char">&ge;</span>3). Depending on the
                      severity, withhold AYVAKIT and then resume at same dose or
                      at a reduced dose upon improvement, or permanently
                      discontinue.
                    </p>
                    <p>
                      <strong>Photosensitivity&mdash;</strong>AYVAKIT may cause
                      photosensitivity reactions. In all patients treated with
                      AYVAKIT in clinical trials (n=1049), photosensitivity
                      reactions occurred in 2.5% of patients. Advise patients to
                      limit direct ultraviolet exposure during treatment with
                      AYVAKIT and for one week after discontinuation of
                      treatment.
                    </p>
                    <p>
                      <strong>Embryo-Fetal Toxicity&mdash;</strong>AYVAKIT can
                      cause fetal harm when administered to a pregnant woman.
                      Advise pregnant women of the potential risk to a fetus.
                      Advise females and males of reproductive potential to use
                      an effective contraception during treatment with AYVAKIT
                      and for 6 weeks after the final dose of AYVAKIT. Advise
                      women not to breastfeed during treatment with AYVAKIT and
                      for 2 weeks following the final dose.
                    </p>
                    <p>
                      <strong>Adverse Reactions&mdash;</strong>The most common
                      adverse reactions (<span className="ge-char">&ge;</span>
                      20%) were edema, nausea, fatigue/asthenia, cognitive
                      impairment, vomiting, decreased appetite, diarrhea,
                      increased lacrimation, abdominal pain, constipation, rash,
                      dizziness, and hair color changes.
                    </p>
                    <p>
                      <strong>Drug Interactions&mdash;</strong>Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inhibitors. If coadministration with a moderate CYP3A
                      inhibitor cannot be avoided, reduce dose of AYVAKIT. Avoid
                      coadministration of AYVAKIT with strong or moderate CYP3A
                      inducers. If contraception requires estrogen, limit
                      ethinyl estradiol to <span className="ge-char">&le;</span>
                      20 mcg unless a higher dose is necessary.
                    </p>
                    <p>
                      To report suspected adverse reactions, contact Blueprint
                      Medicines Corporation at 1-888-258-7768 or the FDA at
                      1-800-FDA-1088 or{" "}
                      <a
                        className="above-accent"
                        href="https://www.fda.gov/medwatch"
                        target="_blank"
                      >
                        www.fda.gov/medwatch
                      </a>
                      .
                    </p>

                    <p>
                      AYVAKIT is available in 100-mg, 200-mg, and 300-mg
                      tablets.
                    </p>
                    <p>
                      <strong>
                        Please click here to see the full{" "}
                        <a
                          href="https://www.blueprintmedicines.com/wp-content/uploads/uspi/AYVAKIT.pdf"
                          download
                          target="_blank"
                        >
                          Prescribing Information
                        </a>{" "}
                        for AYVAKIT.
                      </strong>
                    </p>
                    <p>
                      <strong>References:</strong>
                    </p>
                    <ol class="gist-references">
                      <li>
                        <span>
                          AYVAKIT [prescribing information]. Cambridge, MA:
                          Blueprint Medicines Corporation; November 2024.
                        </span>
                      </li>
                      <li>
                        <span>
                          Evans EK et al. <em>Sci Transl Med.</em>{" "}
                          2017;9(414):eaao1690.
                        </span>
                      </li>
                      <li>
                        <span>
                          Referenced with permission from the NCCN Clinical
                          Practice Guidelines in Oncology (NCCN Guidelines
                          <sup className="reg_mark">®</sup>) for
                          Gastrointestinal Stromal Tumors V.2.2024. © National
                          Comprehensive Cancer Network, Inc. 2024. All rights
                          reserved. Accessed September 18, 2024. To view the
                          most recent and complete version of the guideline, go
                          online to NCCN.org. NCCN makes no warranties of any
                          kind whatsoever regarding their content, use or
                          application and disclaims any responsibility for their
                          application or use in any way.
                        </span>
                      </li>
                      <li>
                        <span>
                          Casali PG et al. <em>Ann Oncol.</em>{" "}
                          2018;29(4):iv68-iv78.
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default GlobalISI
